let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("fOtNs")]).then(() => parcelRequire('6ZDf9'));